import { useState } from 'react';
import Intro from './components/Intro';
import Uploader from './components/Uploader';
import Form from './components/Form';
import { Logo } from './components/Logo';
import { useLayout } from './LayoutContext';
import { useLocation } from 'react-router-dom';
import VideoRecorder from './components/VideoRecorder';
import AudioRecorder from './components/AudioRecorder';
import AgentGenerator from './components/AgentGenerator';
import WebcamCapture from './components/WebcamCapture';
import DeepfakeGenerator from './components/DeepfakeGenerator';

const Sampler = () => {
    const { layout } = useLayout();
    const [screen, setScreen] = useState<'intro' | 'recorder' | 'uploader' | 'webcam' | 'form'>('intro');
    const location = useLocation();

    const isDeepfake = location.pathname.includes("/deepfake");
    const isAudio = location.pathname.includes("/audio");
    const isVideo = location.pathname.includes("/video");

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            fontFamily: "'Nunito Sans', sans-serif",
            position: 'relative',
        }}>
            <Logo logo={layout.logo} />

            <div className="flex items-center justify-center" style={{ width: '100%', maxWidth: 440, flex: 1 }}>
                {screen === 'intro' && (
                    <Intro setScreen={setScreen} />
                )}
                {screen === 'uploader' && (
                    <Uploader setScreen={setScreen} />
                )}
                {screen === 'recorder' && (
                    isAudio ? (
                        <AudioRecorder setScreen={setScreen} />
                    ) : isDeepfake ? (
                        <AudioRecorder setScreen={setScreen} nextScreen="webcam" />
                    ) : isVideo ? (
                        <VideoRecorder setScreen={setScreen} />
                    ) : null
                )}
                {screen === 'webcam' && (
                    <WebcamCapture setScreen={setScreen} />
                )}
                {screen === 'form' && (
                    isDeepfake ? (
                        <DeepfakeGenerator setScreen={setScreen} />
                    ) : isAudio ? (
                        <AgentGenerator setScreen={setScreen} />
                    ) : isVideo ? (
                        <Form setScreen={setScreen} />
                    ) : null
                )}
            </div>

            {/* Book a Demo footer */}
            <div style={{
                padding: '20px 0',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
            }}>
                <a
                    href="https://cal.com/breacher.ai/30-min-meeting-enterprise"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: '#22FFAF',
                        fontSize: 13,
                        fontWeight: 600,
                        textDecoration: 'none',
                        transition: 'opacity 0.2s',
                        fontFamily: "'Nunito Sans', sans-serif",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.opacity = '0.7')}
                    onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
                >
                    Book a Demo →
                </a>
            </div>
        </div>
    );
};

export default Sampler;
